<div [class]="containerClass">
  <ng-container *ngFor="let iconPath of iconPaths">
    <i *ngIf="isSvg(iconPath)" [inlineSVG]="iconPath"></i>
    <img *ngIf="!isSvg(iconPath)" [src]="iconPath" alt="">
  </ng-container>
  <span *ngIf="!hideText">{{value}}</span>
</div>
